import { Alert, Button, Checkbox, Group, Modal, Stack, Text, Title } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { IconBrandWhatsapp, IconFileTypePdf, IconInfoCircle } from "@tabler/icons-react";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { jobsApi } from "../lib/api";

export function CandidateJdModal({ jobId, opened, onClose }: { jobId: string; opened: boolean; onClose: () => void }) {
  const [includePhone, setIncludePhone] = useState(false);
  const [includeEmail, setIncludeEmail] = useState(false);
  const payload = { include_recruiter_phone: includePhone, include_recruiter_email: includeEmail };
  const pdf = useMutation({
    mutationFn: () => jobsApi.downloadCandidateJd(jobId, payload),
    onSuccess: () => notifications.show({ color: "green", message: "Candidate JD downloaded." }),
    onError: (error) => notifications.show({ color: "red", message: error instanceof Error ? error.message : "Could not create the JD" }),
  });
  const whatsapp = useMutation({
    mutationFn: () => jobsApi.candidateJdWhatsApp(jobId, payload),
    onSuccess: async ({ text }) => {
      await navigator.clipboard.writeText(text);
      notifications.show({ color: "green", message: "WhatsApp-ready JD copied to your clipboard." });
    },
    onError: (error) => notifications.show({ color: "red", message: error instanceof Error ? error.message : "Could not create the JD" }),
  });

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Create candidate-ready JD"
      closeButtonProps={{ "aria-label": "Close" }}
      centered
      size="md"
    >
      <Stack gap="md">
        <Stack gap="var(--axio-unit-2)">
          <Title order={5}>Share a professional, candidate-safe brief</Title>
          <Text size="sm" c="dimmed">
            The JD uses the job’s current approved details, includes your candidate intake link, and is branded Powered by AxioHire.
          </Text>
        </Stack>
        <Alert icon={<IconInfoCircle size="var(--axio-unit-16)" />} color="violet" variant="light">
          Your phone and email are private by default. Add them only when you want candidates to contact you directly.
        </Alert>
        <Checkbox checked={includePhone} onChange={(event) => setIncludePhone(event.currentTarget.checked)} label="Include my phone / WhatsApp" />
        <Checkbox checked={includeEmail} onChange={(event) => setIncludeEmail(event.currentTarget.checked)} label="Include my email" />
        <Group grow align="stretch">
          <Button leftSection={<IconFileTypePdf size="var(--axio-unit-17)" />} variant="filled" color="violet" loading={pdf.isPending} onClick={() => pdf.mutate()}>
            Download PDF
          </Button>
          <Button leftSection={<IconBrandWhatsapp size="var(--axio-unit-17)" />} variant="light" color="green" loading={whatsapp.isPending} onClick={() => whatsapp.mutate()}>
            Copy WhatsApp text
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
